"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function PatioDoorRepairServicesInSaintLambert() {
  const {
    ref: headingRef,
    isVisible: headingVisible
  } = useRevealOnScroll();
  const {
    ref: textRef,
    isVisible: textVisible
  } = useRevealOnScroll();
  return <section data-section-id="252625" id="hero-section" className="relative w-full min-h-[800px] flex items-center overflow-hidden bg-primary">
      {}
      <div className="absolute inset-0 w-full h-full">
        <div className="absolute inset-0 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663124/img/consular_visa_services_hero.png)]" aria-hidden="true" />
        <div className="absolute inset-0 bg-gradient-to-r from-primary/90 via-primary/50 to-primary/20" />
      </div>

      {}
      <div className="relative z-10 w-full px-6 md:px-[120px] py-20 md:py-[160px]">
        <div className="grid grid-cols-1 gap-12 items-center">
          
          {}
          <div className="space-y-8">
            <div ref={headingRef} className={`transition-all duration-1000 ease-out ${headingVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
              <span className="inline-block font-mono text-xs font-bold tracking-widest text-secondary uppercase mb-4">
                Servizi Diplomatici Premium
              </span>
              <h1 className="font-serif text-4xl md:text-6xl lg:text-7xl font-bold text-white leading-tight tracking-tighter">
                Eccellenza nella <br />
                <span className="text-secondary">Mobilità Globale</span>
              </h1>
            </div>

            <div ref={textRef} className={`transition-all duration-1000 delay-200 ease-out ${textVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
              <p className="font-default text-lg md:text-xl text-white/80 max-w-xl leading-relaxed">
                Consulenza strategica e assistenza d'élite per l'ottenimento di visti consolari e turistici. Gestiamo la complessità burocratica con precisione istituzionale per garantire il vostro successo internazionale.
              </p>
            </div>
          </div>

        </div>
      </div>
    </section>;
}